export enum SettingChat {
  general = 0,
  profile = 1,
  appearance = 2,
  message = 3,
  notification = 4,
  chat = 5,
}

export enum TabOpts {
  Chat = 1,
  Gallery = 2,
}

export enum FilterGallery {
  All = 1,
  File = 2,
  Links = 3,
  Media = 4,
}

export const chatType = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', ' image/*'];

export enum TYPE_REACTS_EMOJI {
  like = 1,
  love = 2,
  yay = 3,
  wow = 4,
  haha = 5,
  sad = 6,
  angry = 7,
}

export const listReactEmoji = {
  1: {
    value: TYPE_REACTS_EMOJI.like,
    label: 'like',
  },
  2: {
    value: TYPE_REACTS_EMOJI.love,
    label: 'love',
  },
  3: {
    value: TYPE_REACTS_EMOJI.yay,
    label: 'yay',
  },
  4: {
    value: TYPE_REACTS_EMOJI.wow,
    label: 'wow',
  },
  5: {
    value: TYPE_REACTS_EMOJI.haha,
    label: 'haha',
  },
  6: {
    value: TYPE_REACTS_EMOJI.sad,
    label: 'sad',
  },
  7: {
    value: TYPE_REACTS_EMOJI.angry,
    label: 'angry',
  },
};

export enum ContactType {
  CONVERSATION = 0,
  USERS = 1,
}

export enum ReadType {
  ALL = 0,
  UNREAD = 1,
}
